import $ from 'jquery';
import Globals from '@/helpers/globals';

const { $body } = Globals;

const Sidebar = {
    init() {
        $body.on('click', '.js-sidebar-link', e => this.handleSidebarLink(e));
    },

    handleSidebarLink(e) {
        e.preventDefault();
        const $curr = $(e.currentTarget);

        if (!$curr.parent().hasClass('active')) window.location = $curr.attr('href');

        $curr.parents('.sidebar-list').toggleClass('open');
    },
};

export default Sidebar;
